<template>
    <div>
        <Card
            :title="plan.nickname || plan.name"
            read="Edit"
            @read="load()"
            write="Save"
            @write="save()"
            remove="Remove"
            @remove="remove()"
        >
            <Input text="Name" v-model="mutatedPlan.name" disabled />
            <Input text="Nickname" v-model="mutatedPlan.nickname" />
            <Input text="Description" v-model="mutatedPlan.description" />
            <Input
                text="Static"
                v-model="mutatedPlan.billingAmount"
                :append="mutatedPlan.billingAmount | formatCurrency"
            />
            <Input
                text="Per GB"
                v-model="mutatedPlan.billingAmountPerGB"
                :append="mutatedPlan.billingAmountPerGB | formatCurrency"
            />
            <Input
                text="Per hour"
                v-model="mutatedPlan.billingAmountPerHour"
                :append="mutatedPlan.billingAmountPerHour | formatCurrency"
            />
            <Input
                text="Initial"
                v-model="mutatedPlan.initialCharge"
                :append="mutatedPlan.initialCharge | formatCurrency"
            />
            <Input
                text="Period"
                v-model="mutatedPlan.billingInterval"
                :append="mutatedPlan.billingInterval | formatTime"
            />
            <Input
                text="Access level"
                v-model="mutatedPlan.accessLevel"
                :append="mutatedPlan.accessLevel | formatAccessLevel"
                type="number"
            />
            <Input
                text="Data cap"
                v-model="mutatedPlan.dataCap"
                :append="mutatedPlan.dataCap | formatData"
            />
            <Input
                text="Time cap"
                v-model="mutatedPlan.timeCap"
                :append="mutatedPlan.timeCap | formatMinute"
            />
            <Input
                text="Device limit"
                v-model="mutatedPlan.deviceLimit"
                type="number"
            />
        </Card>
    </div>
</template>

<script>
    import Input from '@/components/form/input'
    import Card from '@/components/general/card'

    export default {
        props: ['id'],
        data() {
            return {
                mutatedPlan: {}
            }
        },
        methods: {
            load() {
                return this.$store
                    .dispatch('admin/plans/loadByID', this.plan._id)
                    .then(() => {
                        this.mutatedPlan = { ...this.plan }
                    })
            },
            save() {
                return this.$store
                    .dispatch('admin/plans/save', this.mutatedPlan)
                    .then(() => {
                        this.$bvToast.toast('Plan saved.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            },
            remove() {
                return this.$store
                    .dispatch('admin/plans/remove', this.plan._id)
                    .then(() => {
                        this.$bvToast.toast('Plan removed.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            }
        },
        computed: {
            plan() {
                return this.$store.getters['admin/plans/getByID'](this.id)
            }
        },
        components: {
            Input,
            Card
        }
    }
</script>